// src/pages/admin/NoticeofDissolution(1st Publication).js
import React from "react";
import PrintField from "../../shared/PrintField";
import "./NoticeofDissolution1stPublication.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

// ⚠️ ตรงนี้ต้องเป็น forwardRef
const Notice1Form = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ให้ ref มาเกาะที่กระดาษ A4 โดยตรง */}
      <div className="inv-paper" ref={ref}>
        <div className="inv-header-right">
          <div className="inv-bold">
            บริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "200px" }}
            />
          </div>
          <div className="inv-header-date inv-bold">
            วันที่{" "}
            <InputField
              className="inv-line inv-line-short "
              style={{ width: "50px" }}
            />
            เดือน{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
            />
            ปี{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
            />
          </div>
        </div>

        <div className="inv-body">
          <div className="inv-row">
            <span className="inv-bold">
              เรื่อง&nbsp;&nbsp;ขอเชิญประชุมวิสามัญผู้ถือหุ้นประจำปี ครั้งที่
            </span>
            <InputField className="inv-line inv-line-date" style={{ width: "30px" }} /> /
            <InputField className="inv-line inv-line-date" style={{ width: "30px" }} />
          </div>

          <div className="inv-row inv-row-learn inv-bold">
            เรียน&nbsp;&nbsp;ท่านผู้ถือหุ้นของบริษัท
          </div>

          <p className="inv-paragraph">
            ด้วยคณะกรรมการของทางบริษัทฯ ได้มีมติให้เรียกประชุมวิสามัญผู้ถือหุ้น
            <br />
            ครั้งที่
            <InputField className="inv-line inv-line-tiny" style={{ width: "40px" }} /> /
            <InputField className="inv-line inv-line-tiny" style={{ width: "40px" }} />
            ในวันที่
            <InputField className="inv-line inv-line-date" style={{ width: "40px" }} />
            เดือน
            <InputField className="inv-line inv-line-date" style={{ width: "70px" }} />
            ปี
            <InputField className="inv-line inv-line-date" style={{ width: "60px" }} />
            เวลา
            <InputField className="inv-line inv-line-date" style={{ width: "50px" }} /> น.
            <br />
            ณ สำนักงานเลขที่
            <InputField className="inv-line inv-line-long" style={{ width: "140px" }} />
            เพื่อพิจารณาเรื่องต่างๆ ตามระเบียบวาระดังต่อไปนี้คือ
          </p>

          <div className="inv-agenda">
            <div className="inv-agenda-item">
              วาระที่ 1 พิจารณาลงมติพิเศษเรื่องการเลิกบริษัท              
            </div>
            <div className="inv-agenda-item">
              วาระที่ 2 พิจารณาแต่งตั้งผู้ชำระบัญชี
            </div>
            <div className="inv-agenda-item">
              วาระที่ 3 พิจารณาแต่งตั้งผู้สอบบัญชี
            </div>
            <div className="inv-agenda-item">
              วาระที่ 4 พิจารณาเรื่องอื่น ๆ (ถ้ามี)
            </div>
          </div>

          <p className="inv-paragraph">
            ดังนั้น จึงขอเรียนเชิญท่านผู้ถือหุ้นเข้าประชุมตามวัน เวลา
            และสถานที่ดังกล่าวข้างต้น โดยพร้อมเพียงกันด้วย จะขอบคุณอย่างยิ่ง
          </p>

          <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>
            <div className="inv-sign-block">
              <InputField className="inv-sign-line" optional />
              ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              <div>กรรมการ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Notice1Form;
